import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 1228px;
  margin: 0 auto;
`;
